/**
 * Mobile header expand drawer — navigation panel grows inside the header (mega layout).
 */
class HeaderMobileDrawer {
  constructor() {
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
    this.header = document.querySelector('.header--has-expand-drawer');
    this.wrapper = document.querySelector('.header-wrapper');
    this.navToggle = document.querySelector('.js-header-nav-toggle');
    this.navPanel = document.getElementById('HeaderNavPanel');

    if (!this.header) return;

    this.onNavToggle = this.onNavToggle.bind(this);
    this.onDesktopChange = this.onDesktopChange.bind(this);

    this.navToggle?.addEventListener('click', this.onNavToggle);
    this.desktopMediaQuery.addEventListener('change', this.onDesktopChange);

    document.addEventListener('keyup', (event) => {
      if (event.code !== 'Escape' || this.isDesktop()) return;
      if (this.header.classList.contains('header--nav-open')) {
        this.closeNav(true);
      }
    });

    if (!this.isDesktop()) {
      this.reset();
    }
  }

  isDesktop() {
    return this.desktopMediaQuery.matches;
  }

  onDesktopChange(event) {
    if (event.matches) {
      this.reset();
    }
  }

  reset() {
    this.closeNav(false);
    this.setExpandOpen(false);
    this.navPanel
      ?.querySelectorAll('details[open]')
      .forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
  }

  onNavToggle() {
    if (this.isDesktop()) return;

    if (this.header.classList.contains('header--nav-open')) {
      this.closeNav(true);
    } else {
      this.openNav();
    }
  }

  openNav() {
    if (this.isDesktop()) return;

    this.header.classList.add('header--nav-open');
    this.navToggle?.setAttribute('aria-expanded', 'true');
    this.navPanel?.setAttribute('aria-hidden', 'false');
    this.setExpandOpen(true);
    this.queueMeasure();

    window.requestAnimationFrame(() => {
      trapFocus(this.navPanel, this.navToggle);
    });
  }

  closeNav(updateToggle = true) {
    this.header.classList.remove('header--nav-open');
    if (updateToggle) {
      this.navToggle?.setAttribute('aria-expanded', 'false');
    }
    this.navPanel?.setAttribute('aria-hidden', 'true');
    this.setExpandOpen(false);
    removeTrapFocus(this.navToggle);
  }

  setExpandOpen(isOpen) {
    document.body.classList.toggle('overflow-hidden', isOpen);
    document.body.classList.toggle('has-header-nav-open', isOpen);
    document.body.classList.toggle('has-header-mega-open', isOpen);
    this.wrapper?.classList.toggle('header-wrapper--expand-open', isOpen);
  }

  queueMeasure() {
    window.requestAnimationFrame(() => {
      document.dispatchEvent(new CustomEvent('headerMegaMenuMeasure'));
    });
  }
}

function initHeaderMobileDrawer() {
  new HeaderMobileDrawer();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderMobileDrawer);
} else {
  initHeaderMobileDrawer();
}
